(function () {
  var params = new URLSearchParams(window.location.search);
  var promo = params.get('promo');

  var allowedPromos = [
    'JULY4'
  ];

  if (promo && allowedPromos.includes(promo)) {
    document.documentElement.classList.add('promo-active');
    document.documentElement.classList.add('promo-' + promo + '-active');

    if (document.body) {
      document.body.classList.add('promo-active');
      document.body.classList.add('promo-' + promo + '-active');
    }
  }
})();